module.exports = __webpack_public_path__ + "img/parallax3-450p.8d925c15.jpg";